import React, { useEffect, useState } from 'react'
import FetchApi from '../../customhooks/functionFetchApi';
import Button from 'react-bootstrap/Button';
import DataTable from 'react-data-table-component';
import { columns } from './columntable';
import Spinner from 'react-bootstrap/Spinner';


const Journalbomllist = () => {
  var FetchApis = new FetchApi();

  const [datajourlist, setDatajourlist] = useState([]);
  const [textSearch, setTextSearch] = useState([])
  const[reload,setReload]=useState(false);


  useEffect(() => {
    getjournallist();
  }, [])

  function getjournallist() {
    FetchApis.FethcGet(`/journal/journalStatusFinish`).then(res => {
      setDatajourlist(res.data.data)
      setTextSearch(res.data.data);
      setReload(true);
    });

  }

  //ค้นหาข้อมูลทั้งหมด
  function heandleSearch(e) {
    const { value, name } = e.target;

    const filteredData = datajourlist.filter((item) => {
      return Object.values(item).join('').toLowerCase().includes(value.toLowerCase())
    })

    setTextSearch(filteredData)
  }

  function isCreateBom() {
    const databom = datajourlist.filter((item) => item.newbom == '1' || item.newroute == '1')
    setTextSearch(databom)
  }

  function isNotCreateBom() {
    const databom = datajourlist.filter((item) => item.newbom == '0')
    setTextSearch(databom)
  }

  function isListAll() {
    setTextSearch(datajourlist)
  }

  const customStyles = {
    headRow: {
      style: {
        border: 'none',
        backgroundColor: '#28B463'
      },
    },
    headCells: {
      style: {
        color: '#ffff',
        fontSize: '14px',
      },
    },
    rows: {
      highlightOnHoverStyle: {
        backgroundColor: 'rgb(230, 244, 244)',
        borderBottomColor: '#FFFFFF',
        borderRadius: '25px',
        outline: '1px solid #FFFFFF',
      },
    },
    pagination: {
      style: {
        border: 'none',
      },
    },
  };

  return (
    <div style={{ width: '100%', padding: 10 }}>
      <div style={{ padding: 10, backgroundColor: '#E9967A' }}> ข้อมูลเอกสาร ทั้งหมด</div>
      {reload && 
        <div style={{ flexDirection: 'row', display: 'flex' }}>
          <div style={{ margin: 10 }}>
            <Button variant="primary" onClick={() => isListAll()}>ทั้งหมด</Button>
          </div>
          <div style={{ margin: 10 }}>
            <Button variant="success" onClick={() => isCreateBom()}>รายที่ละเบียนแล้ว</Button>
        </div>
        <div style={{ margin: 10 }}>

          <Button variant="warning" onClick={() => isNotCreateBom()}>รายที่ยังไม่ได้ลงทะเบียน</Button>
        </div>
        <div style={{ margin: 10 }}>
          <input type='text' name='search' placeholder='ค้นหา' onChange={(e) => heandleSearch(e)} style={{ width: 250 ,height:35}} />
        </div>
      </div>}
{reload ?
      <DataTable
        columns={columns}
        data={textSearch}
        // selectableRows
        pagination
        customStyles={customStyles}
        highlightOnHover
      />:<div style={{
      width:'100',
      height:500,
      flexDirection:'row',
      alignContent:'center',
      justifyContent:'center',alignItems:'center',display:'flex'}}>
        <Spinner animation="grow" variant="primary" size='50'/>
        </div>  }

    </div>
  )
}

export default Journalbomllist 